import { render } from "./WidgetCadre.vue?vue&type=template&id=5305a860&scoped=true"
import script from "./WidgetCadre.vue?vue&type=script&lang=js"
export * from "./WidgetCadre.vue?vue&type=script&lang=js"

import "./WidgetCadre.vue?vue&type=style&index=0&id=5305a860&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5305a860"]])

export default __exports__